<template>
  <div class="card-area">
    <md-card>
      <md-card-header>
        <h5 class="md-title text-center text-bold">Secure ID Verification</h5>
      </md-card-header>
      <md-card-content>
      <h6 class="row justify-content-center ">We use SecureIDVerify to verify your identity.</h6>
        <li>SecureIDverify is a trusted ID verification company</li>
        <li>Your ID document is used for verification purposes by
SecureIDverify, and will not be seen by, stored on or
processed by <strong>ABCwidgets.com</strong></li>
        <li>The process is fast and simple</li>
      </md-card-content>

        <md-button @click="goHome" class="md-raised md-primary"
          >Get Started</md-button
        >

        <md-button class="md-raised" @click="goSVID()">Login / Retrieve SVID</md-button>

        <md-button class="md-raised" @click="goHowWork()">How does it work?</md-button>

    </md-card>
  </div>
</template>

<script>

export default {
  name: "Home",

  data: () => ({
    logIn: true,
  }),

  methods: {
    goSVID(){
      this.$router.push({ name: "LoginSVID"});
    },
    goHowWork(){
      this.$router.push({ name: "Howdoesitwork"});
    },
    goHome() {
    //   this.$router.push({ name: "About", params: { userId: "123" } });
      this.$router.push({ name: "InputUserData"});
    },
  },
};
</script>
<style>
/* .md-card-actions {
  flex-direction: column;
}
.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.md-card {
  display: inline-block;
  padding: 20px;
} */
</style>
